import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';
import { useTheme } from '../../../contexts/ThemeContext';

const QualityGuarantees = () => {
  const { isDarkMode } = useTheme();
  
  const guarantees = [
    {
      icon: 'Shield',
      title: '100% Quality Guarantee',
      description: 'If you\'re not completely satisfied with our service, we\'ll re-clean your items at no extra cost.',
      color: 'text-white',
      bgColor: 'bg-gradient-to-br from-green-500 to-green-600',
      cardBg: isDarkMode ? 'bg-gradient-to-br from-green-900/20 to-green-800/20' : 'bg-gradient-to-br from-green-50 to-green-100',
      borderColor: isDarkMode ? 'border-green-600' : 'border-green-200'
    },
    {
      icon: 'Clock',
      title: 'On-Time Delivery Promise',
      description: 'We guarantee delivery within the promised timeframe. Late delivery means 20% off your next order.',
      color: 'text-white',
      bgColor: 'bg-gradient-to-br from-blue-500 to-blue-600',
      cardBg: isDarkMode ? 'bg-gradient-to-br from-blue-900/20 to-blue-800/20' : 'bg-gradient-to-br from-blue-50 to-blue-100',
      borderColor: isDarkMode ? 'border-blue-600' : 'border-blue-200'
    },
    {
      icon: 'Heart',
      title: 'Fabric Care Expertise',
      description: 'Our trained professionals handle each fabric type with specialized care techniques and premium products.',
      color: 'text-white',
      bgColor: 'bg-gradient-to-br from-pink-500 to-pink-600',
      cardBg: isDarkMode ? 'bg-gradient-to-br from-pink-900/20 to-pink-800/20' : 'bg-gradient-to-br from-pink-50 to-pink-100',
      borderColor: isDarkMode ? 'border-pink-600' : 'border-pink-200'
    },
    {
      icon: 'Leaf',
      title: 'Eco-Friendly Process',
      description: 'We use biodegradable detergents and energy-efficient machines to minimize environmental impact.',
      color: 'text-white',
      bgColor: 'bg-gradient-to-br from-emerald-500 to-emerald-600',
      cardBg: isDarkMode ? 'bg-gradient-to-br from-emerald-900/20 to-emerald-800/20' : 'bg-gradient-to-br from-emerald-50 to-emerald-100',
      borderColor: isDarkMode ? 'border-emerald-600' : 'border-emerald-200'
    }
  ];

  const fabricTypes = [
    {
      name: 'Cotton & Linen',
      care: 'High-temperature wash with enzyme-based stain removal',
      icon: 'Shirt',
      bgColor: isDarkMode ? 'bg-gradient-to-br from-orange-900/20 to-orange-800/20' : 'bg-gradient-to-br from-orange-50 to-orange-100',
      borderColor: isDarkMode ? 'border-orange-600' : 'border-orange-200',
      iconBg: 'bg-orange-500',
      iconColor: 'text-white'
    },
    {
      name: 'Silk & Delicates',
      care: 'Gentle hand wash with pH-balanced detergents',
      icon: 'Sparkles',
      bgColor: isDarkMode ? 'bg-gradient-to-br from-purple-900/20 to-purple-800/20' : 'bg-gradient-to-br from-purple-50 to-purple-100',
      borderColor: isDarkMode ? 'border-purple-600' : 'border-purple-200',
      iconBg: 'bg-purple-500',
      iconColor: 'text-white'
    },
    {
      name: 'Wool & Cashmere',
      care: 'Specialized wool wash with lanolin conditioning',
      icon: 'Snowflake',
      bgColor: isDarkMode ? 'bg-gradient-to-br from-cyan-900/20 to-cyan-800/20' : 'bg-gradient-to-br from-cyan-50 to-cyan-100',
      borderColor: isDarkMode ? 'border-cyan-600' : 'border-cyan-200',
      iconBg: 'bg-cyan-500',
      iconColor: 'text-white'
    },
    {
      name: 'Synthetic Blends',
      care: 'Temperature-controlled wash with anti-static treatment',
      icon: 'Zap',
      bgColor: isDarkMode ? 'bg-gradient-to-br from-yellow-900/20 to-yellow-800/20' : 'bg-gradient-to-br from-yellow-50 to-yellow-100',
      borderColor: isDarkMode ? 'border-yellow-600' : 'border-yellow-200',
      iconBg: 'bg-yellow-500',
      iconColor: 'text-white'
    }
  ];

  const turnaroundTimes = [
    { 
      service: 'Express Service', 
      time: '4-6 hours', 
      icon: 'Zap', 
      color: 'text-white',
      bgColor: 'bg-gradient-to-br from-red-500 to-red-600',
      cardBg: isDarkMode ? 'bg-gradient-to-br from-red-900/20 to-red-800/20' : 'bg-gradient-to-br from-red-50 to-red-100',
      borderColor: isDarkMode ? 'border-red-600' : 'border-red-200'
    },
    { 
      service: 'Same Day', 
      time: '8-12 hours', 
      icon: 'Clock', 
      color: 'text-white',
      bgColor: 'bg-gradient-to-br from-orange-500 to-orange-600',
      cardBg: isDarkMode ? 'bg-gradient-to-br from-orange-900/20 to-orange-800/20' : 'bg-gradient-to-br from-orange-50 to-orange-100',
      borderColor: isDarkMode ? 'border-orange-600' : 'border-orange-200'
    },
    { 
      service: 'Next Day', 
      time: '24 hours', 
      icon: 'Calendar', 
      color: 'text-white',
      bgColor: 'bg-gradient-to-br from-blue-500 to-blue-600',
      cardBg: isDarkMode ? 'bg-gradient-to-br from-blue-900/20 to-blue-800/20' : 'bg-gradient-to-br from-blue-50 to-blue-100',
      borderColor: isDarkMode ? 'border-blue-600' : 'border-blue-200'
    },
    { 
      service: 'Standard', 
      time: '48 hours', 
      icon: 'CheckCircle', 
      color: 'text-white',
      bgColor: 'bg-gradient-to-br from-green-500 to-green-600',
      cardBg: isDarkMode ? 'bg-gradient-to-br from-green-900/20 to-green-800/20' : 'bg-gradient-to-br from-green-50 to-green-100',
      borderColor: isDarkMode ? 'border-green-600' : 'border-green-200'
    }
  ];

  return (
    <div className="space-y-16">
      {/* Quality Guarantees */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
        className="space-y-8"
      >
        <div className="text-center">
          <h2 className="text-3xl font-bold text-foreground mb-4">
            Our Quality Commitments
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            We stand behind every service with industry-leading guarantees and professional care standards.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {guarantees?.map((guarantee, index) => (
            <motion.div
              key={guarantee?.title}
              initial={{ opacity: 0, x: index % 2 === 0 ? -20 : 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className={`${guarantee?.cardBg} rounded-xl p-6 border ${guarantee?.borderColor} hover:shadow-elevation-2 transition-all duration-300`}
            >
              <div className="flex items-start space-x-4">
                <div className={`w-12 h-12 rounded-2xl ${guarantee?.bgColor} flex items-center justify-center flex-shrink-0`}>
                  <Icon name={guarantee?.icon} size={24} className={guarantee?.color} />
                </div>
                <div className="space-y-2">
                  <h3 className={`font-semibold ${isDarkMode ? 'text-primary-foreground' : 'text-foreground'}`}>{guarantee?.title}</h3>
                  <p className={`text-sm leading-relaxed ${isDarkMode ? 'text-primary-foreground/80' : 'text-muted-foreground'}`}>
                    {guarantee?.description}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
      {/* Fabric Care Instructions */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.2 }}
        viewport={{ once: true }}
        className="space-y-8"
      >
        <div className="text-center">
          <h2 className="text-3xl font-bold text-foreground mb-4">
            Specialized Fabric Care
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Each fabric type receives customized treatment based on its unique properties and care requirements.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {fabricTypes?.map((fabric, index) => (
            <motion.div
              key={fabric?.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className={`${fabric?.bgColor} rounded-xl p-6 border ${fabric?.borderColor} hover:shadow-elevation-2 transition-all duration-300`}
            >
              <div className="flex items-center space-x-3 mb-3">
                <div className={`w-10 h-10 rounded-2xl ${fabric?.iconBg} flex items-center justify-center`}>
                  <Icon name={fabric?.icon} size={20} className={fabric?.iconColor} />
                </div>
                <h3 className={`font-semibold ${isDarkMode ? 'text-primary-foreground' : 'text-foreground'}`}>{fabric?.name}</h3>
              </div>
              <p className={`text-sm ${isDarkMode ? 'text-primary-foreground/80' : 'text-muted-foreground'}`}>{fabric?.care}</p>
            </motion.div>
          ))}
        </div>
      </motion.div>
      {/* Turnaround Times */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.4 }}
        viewport={{ once: true }}
        className="space-y-8"
      >
        <div className="text-center">
          <h2 className="text-3xl font-bold text-foreground mb-4">
            Service Timelines
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto">
            Choose the turnaround time that fits your schedule. All times are guaranteed with our on-time delivery promise.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {turnaroundTimes?.map((item, index) => (
            <motion.div
              key={item?.service}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              className={`${item?.cardBg} rounded-xl p-6 text-center border ${item?.borderColor} hover:shadow-elevation-2 transition-all duration-300`}
            >
              <div className={`w-12 h-12 rounded-2xl ${item?.bgColor} mx-auto mb-4 flex items-center justify-center`}>
                <Icon name={item?.icon} size={20} className={item?.color} />
              </div>
              <h3 className={`font-semibold mb-2 ${isDarkMode ? 'text-primary-foreground' : 'text-foreground'}`}>{item?.service}</h3>
              <p className={`text-sm ${isDarkMode ? 'text-primary-foreground/80' : 'text-muted-foreground'}`}>{item?.time}</p>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </div>
  );
};

export default QualityGuarantees;